import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { PreviewModelInstance } from 'src/store/_models/preview';
import { ProductModelInstance } from 'src/store/_models/product';
import { UserImageModelInstance } from 'src/store/_models/userImage';
import { UserImageAreaModelInstance } from 'src/store/_models/userImageArea';
import { EDITOR_VIEW_MODE } from 'src/store/page-project/pageProject.constants';
import { SECTION_NAMES } from 'src/constants/sectionNames.contants';

export const parseAnalyticsSectionName = (view?: string) => {
  return (
    (view &&
      {
        [DYNAMIC_MODAL_VIEWS.QualityAlert]: SECTION_NAMES.QUALITY_ALERT_MODAL,
        [DYNAMIC_MODAL_VIEWS.MultiplePurchase]: SECTION_NAMES.MULTIPLE_PURCHASE_MODAL,
        [DYNAMIC_MODAL_VIEWS.DeleteProduct]: SECTION_NAMES.DELETE_PRODUCT_MODAL,
        [DYNAMIC_MODAL_VIEWS.EmptyImages]: SECTION_NAMES.EMPTY_IMAGES_MODAL,
        [DYNAMIC_MODAL_VIEWS.UploadToCart]: SECTION_NAMES.UPLOAD_TO_CART_MODAL,
        [DYNAMIC_MODAL_VIEWS.ErrorCart]: SECTION_NAMES.ERROR_CART_MODAL,
        [DYNAMIC_MODAL_VIEWS.SaveChanges]: SECTION_NAMES.SAVE_CHANGES_MODAL,
        [DYNAMIC_MODAL_VIEWS.ApplyAll]: SECTION_NAMES.APPLY_ALL_MODAL,
        [DYNAMIC_MODAL_VIEWS.ModalUpSelling]: SECTION_NAMES.MODAL_UP_SELLING_MODAL,
        [DYNAMIC_MODAL_VIEWS.UploadMultiSource]: SECTION_NAMES.UPLOAD_MULTI_SOURCE_MODAL,
        [DYNAMIC_MODAL_VIEWS.PrivacyPolicy]: SECTION_NAMES.PRIVACY_POLICY_MODAL,
        [DYNAMIC_MODAL_VIEWS.CutAlert]: SECTION_NAMES.CUT_ALERT_MODAL,
        [DYNAMIC_MODAL_VIEWS.CutConfirmationAlert]: SECTION_NAMES.CUT_CONFIRMATION_ALERT_MODAL,
        [DYNAMIC_MODAL_VIEWS.ConfigurationSteps]: SECTION_NAMES.CONFIGURATION_STEPS_MODAL,
        [DYNAMIC_MODAL_VIEWS.ExitProject]: SECTION_NAMES.EXIT_PROJECT_MODAL,
        [DYNAMIC_MODAL_VIEWS.DeleteAll]: SECTION_NAMES.DELETE_ALL_MODAL,
        [DYNAMIC_MODAL_VIEWS.ProductNotAvailable]: SECTION_NAMES.PRODUCT_NOT_AVAILABLE_MODAL,
        [DYNAMIC_MODAL_VIEWS.ConfigurationStepsMobile]: SECTION_NAMES.CONFIGURATION_STEPS_MOBILE_VIEW,
        [DYNAMIC_MODAL_VIEWS.AdjustCrops]: SECTION_NAMES.ADJUST_CROPS_VIEW,
        [DYNAMIC_MODAL_VIEWS.EditProducts]: SECTION_NAMES.EDITOR_VIEW, // it's the editor_view for the new print editor
        [EDITOR_VIEW_MODE.editor]: SECTION_NAMES.EDITOR_VIEW, // it's the editor_view for the old frame editor
        [EDITOR_VIEW_MODE.pictureView]: SECTION_NAMES.PICTURE_VIEW,
        [EDITOR_VIEW_MODE.productEditor]: SECTION_NAMES.PRODUCT_EDITOR_VIEW,
      }[view]) ||
    view
  );
};

export const parseAnalyticsParamsByProduct = (product?: ProductModelInstance) => {
  const params: any = {};
  if (product) {
    params.product_name = product.type;
    params.product_configuration_id = product.productConfigurationId;
  }
  return params;
};

export const parseAnalyticsParamsByUserImageArea = (userImageArea?: UserImageAreaModelInstance) => {
  return parseAnalyticsParamsByProduct(userImageArea?.product);
};

export const parseAnalyticsParamsByUserImage = (userImage?: UserImageModelInstance) => {
  return parseAnalyticsParamsByProduct(userImage?.product);
};

export const parseAnalyticsParamsByPreview = (preview?: PreviewModelInstance) => {
  return parseAnalyticsParamsByProduct(preview?.product);
};
